import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ContentDashboard from "./pages/Filmmaker/Dashboard";
import Projects from "./pages/Filmmaker/Projects";
import Profile from "./pages/Filmmaker/Profile";
import OTTDashboard from "./pages/OTT/Dashboard";
import OTTProjects from "./pages/OTT/Projects";
import OTTUnreleased from "./pages/OTT/Unreleased";
import OTTReleased from "./pages/OTT/Released";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminProjects from "./pages/Admin/Projects";
import AdminUnreleased from "./pages/Admin/Unreleased";
import AdminReleased from "./pages/Admin/Released";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import SecurityPolicy from "./pages/SecurityPolicy";
import Disclaimer from "./pages/Disclaimer";
import PaymentsPolicy from "./pages/PaymentsPolicy";
import { Auth } from "./Auth";
import OTTLogin from "./pages/OTTLogin";
import { OTTAuth } from "./OTTAuth";
import { AdminAuth } from "./AdminAuth";
import Investor from "./pages/Investor";
import Filmmaker from "./pages/Filmmaker";
import Unreleased from "./pages/Filmmaker/Unreleased";
import Released from "./pages/Filmmaker/Released";
import AdminLogin from "./pages/AdminLogin";
import Users from "./pages/Admin/Users";
import Ott from "./pages/Admin/Ott";
import UpdateProject from "./pages/Filmmaker/UpdateProject";
import UpdateUnreleased from "./pages/Filmmaker/UpdateUnreleased";
import UpdateReleased from "./pages/Filmmaker/UpdateReleased";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/investor" element={<Investor />} />
          <Route path="/filmmaker" element={<Filmmaker />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/security-policy" element={<SecurityPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/payments-policy" element={<PaymentsPolicy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/ott" element={<OTTLogin />} />
          <Route path="/admin" element={<AdminLogin />} />

          <Route path="/filmmaker/*" element={<Auth />}>
            <Route path="dashboard" element={<ContentDashboard />} />
            <Route path="projects" element={<Projects />} />
            <Route path="update-project" element={<UpdateProject />} />
            <Route path="unreleased" element={<Unreleased />} />
            <Route path="update-unreleased" element={<UpdateUnreleased />} />
            <Route path="released" element={<Released />} />
            <Route path="update-released" element={<UpdateReleased />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          <Route path="/ott/*" element={<OTTAuth />}>
            <Route path="dashboard" element={<OTTDashboard />} />
            <Route path="projects" element={<OTTProjects />} />
            <Route path="unreleased" element={<OTTUnreleased />} />
            <Route path="released" element={<OTTReleased />} />
          </Route>

          <Route path="/admin/*" element={<AdminAuth />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="update-project" element={<UpdateProject />} />
            <Route path="unreleased" element={<AdminUnreleased />} />
            <Route path="update-unreleased" element={<UpdateUnreleased />} />
            <Route path="released" element={<AdminReleased />} />
            <Route path="update-released" element={<UpdateReleased />} />
            <Route path="users" element={<Users />} />
            <Route path="ott" element={<Ott />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
